import React from "react";
import "./style.scss";
import placeholder from "../../../assets/images/placeholder_small.svg";

const StepItem = ({ number, placeholder, step }) => {
  return (
    <div className="step-item">
      <p>{number}</p>
      <div className="placeholder">
        <img src={placeholder} alt="placeholder" />
      </div>
      <h3>{step}</h3>
    </div>
  );
};
const Steps = () => {
  return (
    <div className="steps">
      <StepItem
        number={1}
        placeholder={placeholder}
        step={`Answer a short form, \nautomate the rest`}
      />
      <StepItem
        number={2}
        placeholder={placeholder}
        step={`Receive your offer \nwithin a day`}
      />
      <StepItem
        number={3}
        placeholder={placeholder}
        step={`Close in days, \nnot months`}
      />
    </div>
  );
};
const GetPaidSteps = (props) => {
  return (
    <div className="get_paid_section">
      <h1 className="title">Get paid in 3 easy steps.</h1>
      <Steps />
    </div>
  );
};

export default GetPaidSteps;
